// src/components/sharedLists/ListsChartPage.jsx
//
// /listes - the web hit-parade of the YummiTracker restaurant lists (the
// public ones, by imports + likes over 30 days or all time). Each list opens
// its share page (/l/:code). Replaces the old /OwnerLists page.
import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Container, Typography, Box, Paper, Stack, Tabs, Tab, CircularProgress, Alert,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { charts } from '../../utils/sharedListsApi';
import StoreButtons from './StoreButtons';

export default function ListsChartPage() {
  const { t } = useTranslation();
  const [period, setPeriod] = useState('30d');
  const [lists, setLists] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let alive = true;
    setLists(null); setError(false);
    charts(period).then((l) => { if (alive) setLists(l); }).catch(() => { if (alive) setError(true); });
    return () => { alive = false; };
  }, [period]);

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Typography variant="h4" sx={{ fontWeight: 800 }}>{t('sharedLists.chartsTitle')}</Typography>
      <Typography color="text.secondary" sx={{ mb: 2 }}>{t('sharedLists.chartsIntro')}</Typography>
      <Tabs value={period} onChange={(_e, v) => setPeriod(v)} sx={{ mb: 2 }}>
        <Tab value="30d" label={t('sharedLists.period30d')} />
        <Tab value="all" label={t('sharedLists.periodAll')} />
      </Tabs>
      {error && <Alert severity="warning">{t('sharedLists.loadError')}</Alert>}
      {!lists && !error && <Box sx={{ p: 4, textAlign: 'center' }}><CircularProgress /></Box>}
      {lists && !lists.length && <Typography color="text.secondary">{t('sharedLists.chartsEmpty')}</Typography>}
      <Stack spacing={1}>
        {lists?.map((l) => (
          <Paper key={l.id} component={RouterLink} to={`/l/${l.shareCode}`} variant="outlined"
            sx={{ p: 1.5, display: 'flex', alignItems: 'center', gap: 2, textDecoration: 'none', color: 'inherit' }}>
            <Typography sx={{ fontWeight: 800, fontSize: 22, width: 32, textAlign: 'center', color: l.rank <= 3 ? '#C9A227' : '#1C2B4A' }}>{l.rank}</Typography>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography sx={{ fontWeight: 700 }} noWrap>{l.name}</Typography>
              <Typography variant="body2" color="text.secondary" noWrap>
                {l.author.name}{l.author.verified ? ' ✓' : ''}{l.city ? ` · ${l.city}` : ''} · {t('sharedLists.places', { count: l.itemCount })} · ❤ {l.likes}
              </Typography>
            </Box>
          </Paper>
        ))}
      </Stack>
      <Box sx={{ mt: 4 }}>
        <Typography sx={{ fontWeight: 700, mb: 1 }}>{t('sharedLists.getApp')}</Typography>
        <StoreButtons />
      </Box>
    </Container>
  );
}
